// aws-exports.js
const awsconfig = {
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_ADMIN_USER_POOL_ID,
      userPoolClientId: process.env.REACT_APP_ADMIN_USER_POOL_CLIENT_ID,
      identityPoolId: process.env.REACT_APP_ADMIN_IDENTITY_POOL_ID,
      loginWith: {
        email: true,
      },
      signUpVerificationMethod: "code",
      userAttributes: {
        email: {
          required: true,
        },
      },
      allowGuestAccess: false,
      passwordFormat: {
        minLength: 8,
        requireLowercase: true,
        requireUppercase: true,
        requireNumbers: true,
        requireSpecialCharacters: true,
      },

    },
  },
  Storage: {
    S3: {
      bucket: process.env.REACT_APP_BUCKET_NAME,
      region: process.env.REACT_APP_ADMIN_REGION,
    },
  },
};

export default awsconfig;
